import { render, staticRenderFns } from "./DetailsCard.vue?vue&type=template&id=45e877a4&"
import script from "./DetailsCard.vue?vue&type=script&lang=js&"
export * from "./DetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports